/**
 * Display a choice with a picture, a name, description and price
 * shape parameter allow to show image as a cicle or a square
 */
fx.ns("shared.components", class ProductChoice extends fx.components.VBox
{    
    constructor(shape, data, image, name, description, price, disabled)
    {
        super();

        this.data = data;
        this.image = image; // image can be a function that returns a component. Function will be called with data 
        this.name = name; 
        this.description = description;
        this.price = price;
        this.disabled = disabled;

        this._display = shape || "circle";
    }

    // short label pinned on the picture ("Top Vente"), set before the choice is displayed
    get badge()
    {
        return this._badge;
    }

    set badge(val)
    {
        this._badge = val;
    }

    create()
    {
        super.create();

        this.addChild( typeof this.image == "function" ? this.image(this.data) : new fx.components.ImageButton( {image : this.image } ), {width:"100%", height:"auto", left : "center"} );

        if (this.badge)
            this.addChild( new fx.components.Text( {text : this.badge, className : "badge"} ) );
        
        if (this.name)
            this.addChild( new fx.components.Text( {text : this.name, className : "name"} ), {width:"100%", height : "auto", left : "center"} );

        if (this.description)
            this.addChild( new fx.components.Text( {text : this.description, className : "description"} ), {width:190, left : "center"} );

        if (this.price)
            this.addChild( new fx.components.Text( {text : this.price, className : "price"} ), {width:"auto", left : "center"} );

        if (this.disabled)
            this.addChild( new fx.components.Text( {text : fx.text("Non disponible"), className : "availability"} ), {width:"auto", left : "center"} );

        this.addClass(this._display)
    }

});
